import { useTranslation } from 'react-i18next';

export default function WhySection() {
  const { t } = useTranslation();

  const painPoints = [
    { icon: 'ri-money-dollar-circle-line', title: t('why.item1_title'), desc: t('why.item1_desc') },
    { icon: 'ri-error-warning-line', title: t('why.item2_title'), desc: t('why.item2_desc') },
    { icon: 'ri-chat-delete-line', title: t('why.item3_title'), desc: t('why.item3_desc') },
    { icon: 'ri-truck-line', title: t('why.item4_title'), desc: t('why.item4_desc') },
  ];

  return (
    <section className="py-20 md:py-28 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1100px] mx-auto">
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 text-center tracking-tight">
          {t('why.title')}
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-12">
          {painPoints.map((point, idx) => (
            <div key={idx} className="bg-white rounded-lg p-6 border border-background-200/70 hover:border-background-300/60 transition-colors">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-4">
                <i className={`${point.icon} text-lg`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-2">{point.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{point.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-sm text-foreground-500">
            Решение:
            <strong className="text-primary-600 font-semibold ml-1">YOYBUY Spreadsheet</strong>
          </p>
        </div>
      </div>
    </section>
  );
}